<template lang="pug">
  include ./../../mixins
  +b.modal
    +b.close(
      slot="top-right"
      @click="$emit('close')"
    )
      +b.I.icon.--type_close
    +e.content
      quote-form(
        :url="url"
        :services-url="servicesUrl"
        :is-modal="isModal"
        :unregistered-order-url="unregisteredOrderUrl"
        :service-id="serviceId"
        @close="$emit('close')"
      )
</template>

<script>
export default {
  props: {
    url: String,
    servicesUrl: String,
    unregisteredOrderUrl: String,
    isModal: {
      default: false,
    },
    serviceId: {},
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/Quote.vue